import React, { FC, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  Grid,
  Button,
  TextField,
  IconButton,
  FormHelperText,
  Paper,
  Card,
  CardHeader,
  CardContent,
} from '@material-ui/core';
import theme from '../../../theme';
import { useForm } from 'react-hook-form';
import List from './listInventories';

import warehouseRepository from 'client-sdk/src/Repository/warehouses-repository';

import Icon from '@mdi/react';
import { mdiArrowRight, mdiPaperclip, mdiPlus } from '@mdi/js';
import handleError from '../../../utils/handleError';
import handleNotfication from '../../../utils/handleNotfication.tsx';
import { handleErrorList } from '../../../utils/helpers';
import GroupingCreateOrderMob from './groupingCreateMob';
import windowSize from '../../../utils/hook/useWindowResize';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
      '& .MuiFormControl-marginNormal': {
        marginTop: 0,
      },
    },
    '.margin-date-0': {
      '&.MuiFormControl-marginNormal': {
        marginTop: 0,
      },
    },
    type: {
      flexGrow: 1,
      maxWidth: 500,
    },
    paper: {
      marginTop: '36px',
      width: '100%',
      marginBottom: '36px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
    },
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.success.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    headerBox: {
      marginLeft: '75px',
      display: 'flex',
      alignItems: 'center',
      marginBottom: '10px',
      marginTop: '10px',
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textInput: {
      '& input, .MuiSelect-root': {
        padding: '12px 10px 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },

    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
    },
    icon: {
      color: '#8a8a8a',
      marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8a8a8a',
      marginRight: '8px',
      marginTop: '21px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    typographyCards: {
      fontSize: '16px',
      color: 'white',
      backgroundColor: '#4BCF90',
      padding: '8px 24px 8px 50px',
      marginLeft: '-40px',
    },
    card: {
      marginBottom: '14px',
      overflow: 'visible',
      padding: '14px',
      paddingBottom: '0',
    },

    cardContent: {
      justifyContent: 'space-between',
      paddingLeft: '14px',
    },
    cardContentOrder: {
      paddingBottom: '10px',
    },
    labelInput: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'relative',
      padding: '15px',
      marginTop: '16px',
      borderRadius: '5px',
      border: 'solid 1px #949494',
      borderStyle: 'dashed',
      width: '100%',
      height: '150px',
    },
    uploadInput: {
      cursor: 'pointer',
      alignSelf: 'center',
      position: 'absolute',
      top: '0',
      right: '0',
      width: '100%',
      height: '100%',
      opacity: '0',
    },
  })
);

interface Props {
  history: any;
}

interface Inputs {
  orderType: string;
  origin: string;
  destination: string;
  file: null | string;
}

interface Errors {
  code: number;
  text: string;
}

const GroupingCreateOrder: FC<Props> = ({
  history,
}: Props): React.ReactElement => {
  const {
    register,
    control,
    errors,
    handleSubmit,
    setValue,
    getValues,
    watch,
  } = useForm<Inputs>({
    defaultValues: {
      orderType: '',
      file: null,
    },
  });
  const classes = useStyles();
  const [file, setFile] = useState<any>('');
  const [loading, setLoading] = useState(false as boolean);
  const [data, setData] = useState([]);
  const [errorList, setErrorList] = useState({});
  const [isMob, setIsMob] = useState(false);
  const { width } = windowSize();

  const onSubmit = async ({ file, origin, destination, orderType }: Inputs) => {
    const partnerId = localStorage.getItem('partnerId');
    try {
      setLoading(true);
      const payload = new FormData();
      if (file) {
        payload.append('file', file[0]);
      }
      const response = await warehouseRepository.updateExcelWarehouseInventories(
        {
          payload: { body: payload, partnerId },
        }
      );
      setData(response.data);
      handleNotfication('موجودی ها با موفقیت به روز رسانی شدند', 'success');
    } catch (err) {
      if (err.response?.status === 400) {
        handleNotfication(err.response?.data?.title, 'error');
      }
      if (err?.response?.status === 406) {
        handleNotfication(
          'فرمت فایل اپلود شده صحیح نمیباشد موارد را اصلاح کنید',
          'error'
        );
        setErrorList(handleErrorList(err.response.data));
      }
      handleError(err.response);
    } finally {
      setFile(null);
      setValue('file', null);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  const handleChangeFileInput = (event: any) => {
    setFile(event.target.files[0]);
  };

  return (
    <React.Fragment>
            <Typography variant="h6" component="h2" style={{marginBottom: "24px"}}>
              بارگذاری گروهی تنظیمات موجودی
            </Typography>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        {/* <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {'بازگشت'}
        </Button> */}

        <Grid md={12} lg={12} item>
          <Card
            className={classes.card}
            style={{ marginTop: '0', paddingBottom: '24px' }}
          >
            <CardHeader
              avatar={
                <Grid>
                  <Typography className={classes.typographyCards}>
                    بارگذاری فایل
                  </Typography>
                </Grid>
              }
            />

            <CardContent className={classes.cardContentOrder}>
              <Grid container lg={12} md={12} className={classes.cardContent}>
                <Grid
                  container
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{
                    padding: '0',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                  }}
                >
                  <Grid container sm={5} md={5}>
                    <Grid
                      item
                      xs={12}
                      lg={12}
                      style={{
                        display: 'flex',
                        flexDirection: 'row-reverse',
                        justifyContent: 'right',
                        textAlign: 'right',
                        marginBottom: '-10px',
                      }}
                    >
                      <Link
                        to="/sampleInventory.xlsx"
                        style={{
                          color: '#DFA01F',
                          borderBottom: 'solid 1px #DFA01F',
                          paddingBottom: '3px',
                          textDecoration: 'none',
                        }}
                        target="_blank"
                      >
                        {'دریافت فایل نمونه'}
                      </Link>
                      <Link
                        to="/InventoryInstruction.xlsx"
                        style={{
                          paddingBottom: '3px',

                          color: '#2F4858',
                          marginLeft: '55px',
                          textDecoration: 'none',
                          borderBottom: 'solid 1px #2F4858',
                        }}
                        target="_blank"
                      >
                        {'دریافت فایل راهنما'}
                      </Link>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      lg={12}
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                      }}
                    >
                      <div style={{ display: 'flex', width: '100%' }}>
                        <div className={classes.item}>
                          <br />
                          <label htmlFor="file" className={classes.labelInput}>
                            <Icon
                              color={'#666666'}
                              path={mdiPaperclip}
                              size={2}
                            />
                            <Typography>
                              {file ? file?.name : 'فایل خود را اینجا رها کنید'}
                            </Typography>
                            <Typography
                              style={{
                                color: '#0375E8',
                                borderBottom: 'solid 1px #0375E8',
                              }}
                            >
                              انتخاب فایل از کامپیوتر
                            </Typography>

                            <input
                              id="file"
                              type="file"
                              name="file"
                              onChange={handleChangeFileInput}
                              ref={register({ required: true })}
                              multiple
                              className={classes.uploadInput}
                            />
                          </label>
                        </div>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
        <Grid
          container
          lg={12}
          md={12}
          xs={12}
          spacing={2}
          style={{
            flexDirection: 'row-reverse',
            position: 'fixed',
            backgroundColor: '#D5DADD',
            bottom: '0',
            right: '75px',
            padding: '15px',
            zIndex: 2,
          }}
        >
          <Grid
            container
            style={{
              marginLeft: '35px',
              marginTop: '-4px',
            }}
          >
            <Button
              variant="outlined"
              color="primary"
              size="large"
              onClick={() => window.history.back()}
              style={{
                marginRight: 'auto',
                padding: '2px 30px',
              }}
              data-cy="cancelBtn"
            >
              {'انصراف'}
            </Button>
            <Button
              type="submit"
              disabled={loading}
              size="large"
              data-cy="search"
              autoFocus
              variant="contained"
              color="primary"
              style={{
                marginRight: '14px',
                marginLeft: '90px',
              }}
            >
              ذخیره تنظیمات موجودی
            </Button>
          </Grid>
        </Grid>
      </form>
      {/* <Grid item container justify="flex-start" xs={12}>
        {data?.length} {'موجودی'}
      </Grid> */}
      <Grid
        container
        item
        xs={12}
        alignItems="flex-end"
        style={{ marginTop: '16px' }}
      >
        <div className={classes.item}>
          {data && (
            <>
              <List data={data} />
            </>
          )}
        </div>
      </Grid>
    </React.Fragment>
  );
};

export default GroupingCreateOrder;
